<template>
    <div class="right_kanban common-bg">
      <custom-plane
        title="实时剩余车位"
        :iconImg="require('@/assets/compImg/parking/parking.png')"
      >
        <div class="parkData">
          <span>{{ numb.split("/")[0] }}</span
          ><span>&nbsp;/&nbsp;</span>
          <span class="after">{{ numb.split("/")[1] }}</span>
        </div>
        <div class="progress">
          <div class="level">
            <div class="cont">剩余</div>
            <div class="cont">总量</div>
          </div>
          <div style="width:376px">
            <custom-progress-heightline
              :value="value1"
              :splitCount="40"
            ></custom-progress-heightline>
          </div>
        </div>
      </custom-plane>
    </div>
</template>

<script>
export default {
    data() {
    return {
    };
  },
  props:{
    numb:String
  },
  computed: {
    value1() {
      return (
        (Number(this.numb.split("/")[0]) / Number(this.numb.split("/")[1])) *
        100
      );
    },
  },
}
</script>

<style lang="scss" scoped>
.right_kanban {
  width: 416px;
  height: 165px;

  .parkData {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-family: "dina";
      font-weight: 500;
      font-size: 36px;
    }

    .after {
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .progress {
    height: 38px;
    padding: 0 20px;

    .level {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;

      .cont {
        // margin-top: 14px;
        font-size: 16px;
        letter-spacing: 0.1em;
      }
    }
  }
}
</style>